<template>
    <div class="login">
        <div class="indexLogin">
            <img v-if="seller.logo" :src="getImgUrl(seller.logo)" alt="logo"
                style="display: block;margin: 10% auto;max-width: 128px;" />
            <div v-if="!seller.logo"
                style="height: 180px;text-align: center;line-height: 180px;font-size: 16px;font-weight: 600;">{{
                    seller.restaurantName }}</div>

            <mu-form ref="form" :model="tableOrderInfo" class="mu-demo-form">
                <mu-form-item :label="$t('login.name')" prop="name" :rules="usernameRules">
                    <mu-text-field v-model="tableOrderInfo.name" prop="name" autocomplete="name"></mu-text-field>
                </mu-form-item>

                <mu-form-item :label="$t('login.telephone')" prop="telephone" :rules="phoneRules"   >
                    <mu-text-field v-model="tableOrderInfo.telephone" prop="telephone" @input="formatPhone"
                        autocomplete="tel"></mu-text-field>
                </mu-form-item>

                <!--<mu-form-item label="Number" prop="Voksne">
                <mu-select label="" v-model="tableOrderInfo.Voksne" full-width>
                    <mu-option v-for="option,index in options" :key="option" :label="option" :value="option"></mu-option>
                </mu-select>

                <mu-text-field v-model="tableOrderInfo.Voksne" prop="Voksne"></mu-text-field>
            </mu-form-item>-->
                <mu-form-item>
                    <mu-checkbox v-model="chkSendSms" value="1" :label="$t('login.accepetSendMsg')"></mu-checkbox>
                </mu-form-item>
                <mu-form-item style="margin:auto;text-align:center;">
                    <mu-button color="primary" large full-width @click="enterOrder"
                        style="background-color:#da5b3a;width:94%;text-transform: unset;">
                        {{ $t('login.begin') }}
                    </mu-button>
                     <mu-button color="#ccc"  large full-width  @click="anonymousEnter" v-if="tableOrderInfo.orderType != 2"
                        style="width:94%;text-transform: unset;" >
                        {{ $t('login.anonymous') }}</mu-button>
                        <!-- <a style="color:#ccc;padding-top:15px;width:100%;text-align: center;font-size: 18px;" @click="anonymousEnter" v-if="tableOrderInfo.orderType != 2">
                            {{ $t('login.anonymous') }}
                         </a> -->
                </mu-form-item>
            </mu-form>
        </div>
        <div style="position:absolute;top:10px;right:-75px;z-index:1000">
            <mu-menu cover :open.sync="isMenuOpen">
                <mu-button fab small color="success" style="position:absolute;right:88px;">
                    {{ getLanage() }}
                </mu-button>
                <mu-list slot="content">
                    <mu-list-item button @click="selectLanage('DK')">
                        <mu-list-item-title>DK</mu-list-item-title>
                    </mu-list-item>
                    <mu-list-item button @click="selectLanage('EN')">
                        <mu-list-item-title>EN</mu-list-item-title>
                    </mu-list-item>
                    <mu-list-item button @click="selectLanage('PT')">
                        <mu-list-item-title>PT</mu-list-item-title>
                    </mu-list-item>
                    <mu-list-item button @click="selectLanage('中文')">
                        <mu-list-item-title>中文</mu-list-item-title>
                    </mu-list-item>
                </mu-list>
            </mu-menu>
        </div>

    </div>
</template>

<script>
import { formatDate } from '../utils/formatDate'
import preventBack from 'vue-prevent-browser-back';
export default {
    mixins: [preventBack],//注入  阻止返回上一页
    data() {
        return {

            seller: {},
            styleChange: {

            },
            configsData: {},
            chkSendSms: true,
            chkTxt: "Agree to send SMS",
            isMenuOpen: false,
            tableOrderInfo: {
                name: '',
                tableName: '',
                orderType: 1,
                restaurantId: 0,
                telephone: '',
                number: 1,
                specielle: '',
                isSendSms: 1
            },
            options: [
                '1', '2', '3', '4',
                '5', '6', '7', '8',
                '9', '10', '11', '12', '13', '14',
                '15', '16', '17', '18',
                '19', '20'
            ],
            fullscreen: false,
        }
    },
    computed: {
        usernameRules() {
            return [{
                validate: (val) => !!val,
                message: this.$t("login.nameNotNull")
            }];
        },
        phoneRules() {
            return [{
                validate: (val) => !!val,
                message: this.$t("login.phoneNotNull")
            }];
        },
    },
    created() {

    },
    mounted() {
        if (this.$route.query.jumpPath != undefined && this.$route.query.jumpPath != null) {
            this.tableOrderInfo = {
                name: "guest",
                telephone: "00000000",
                tableName: "01",
                restaurantId: this.$route.query.restaurantId,
                currentMenuId: this.$route.query.currentMenuId,
                subMenuId: this.$route.query.subMenuId,
            };
            this.setItem('sessionStorage', 'tableOrderInfo', this.tableOrderInfo, 7200000);
            localStorage.setItem('tableOrderInfo', JSON.stringify(this.tableOrderInfo));
            this.$get('QRCodeBasicInfo/GetRestaurant', { restaurantId: this.tableOrderInfo.restaurantId })
                .then(response => {
                    if (response.code == 200) {
                        let data = response.data;
                        this.seller = data;
                        localStorage.setItem('lang', this.seller.language);
                        this.getLanage();
                        localStorage.setItem('seller', JSON.stringify(this.seller));
                        this.$router.push({
                            path: "/" + this.$route.query.jumpPath,
                            query: { restaurantId: this.$route.query.restaurantId, v: Math.random() }
                        })
                    }
                })
            return;
        }
        this.tableOrderInfo.restaurantId = this.$route.query.restaurantId;
        this.tableOrderInfo.tableName = this.$route.query.tableName;
        this.tableOrderInfo.orderType = this.$route.query.type;
        if (this.tableOrderInfo.restaurantId == undefined || this.tableOrderInfo.restaurantId == null || this.tableOrderInfo.restaurantId == 0) {
            this.$router.push({
                path: '/error',
                query: {}
            })
        }
        if (this.tableOrderInfo.orderType != 2) {
            if (this.tableOrderInfo.tableName == undefined || this.tableOrderInfo.tableName == null || this.tableOrderInfo.tableName == '') {
                this.$router.push({
                    path: '/error',
                    query: {}
                })
            }
        }
        if (this.tableOrderInfo.orderType == undefined || this.tableOrderInfo.orderType == null || this.tableOrderInfo.orderType == '') {
            this.$router.push({
                path: '/error',
                query: {}
            })
        }
        this.getRestaurantInfo();

    },
    methods: {
        async getConfigs() {
            await this.$get('QRCodeBasicInfo/GetConfigs', { restaurantId: this.tableOrderInfo.restaurantId })
                .then(response => {
                    if (response.code == 200) {
                        response.data.forEach((item) => {
                            this.configsData[item.configKey] = item.configValue;
                        })
                        this.chkTxt = this.configsData.SendSMSTip;
                    }
                });
        },
        getRestaurantInfo() {
            let param = {
                restaurantId: this.tableOrderInfo.restaurantId
            };
            this.$get('QRCodeBasicInfo/GetRestaurant', param)
                .then(response => {
                    if (response.code == 200) {
                        let data = response.data;
                        this.seller = data;
                        this.getConfigs();
                        let img = new Image()
                        img.src = this.getImgUrl(data.logo)
                        if (img.width == img.height) {
                            this.styleChange = {
                                width: '100px',
                                height: '100px',
                                display: 'block',
                                margin: '10% auto',
                                borderRadius: '50px'
                            }
                        }
                        else {
                            this.styleChange = {
                                width: '128px',
                                height: '96px',
                                display: 'block',
                                margin: '10% auto'
                            }
                        }
                        localStorage.setItem('lang', this.seller.language);
                        this.getLanage();
                        localStorage.setItem('seller', JSON.stringify(this.seller));
                        this.getTableOrderInfo();
                    } else {
                        this.$alert('The web cannot be accessed, please contact the manager!', 'Alert');
                    }
                });
        },
        getLanage() {
            if (localStorage.getItem('lang') != undefined && localStorage.getItem('lang') != null) {
                this.$i18n.locale = localStorage.getItem('lang');
                return localStorage.getItem('lang');
            }
            this.$i18n.locale = this.seller.language;
            return this.seller.language;
        },
        selectLanage(lng) {
            this.$i18n.locale = lng;
            localStorage.setItem('lang', lng);
            this.isMenuOpen = false;
        },
        getImgUrl(image) {
            if (image == undefined || image == 'undefined') {
                return null;
            }
            return this.imageBaseUrl + image;
        },
        anonymousEnter() {
            this.tableOrderInfo.name = 'guest';
            this.tableOrderInfo.telephone = '00000000';
            this.enterOrder();
        },
        enterOrder() {
            this.tableOrderInfo.restaurantId = this.$route.query.restaurantId;
            this.tableOrderInfo.tableName = this.$route.query.tableName;
            this.tableOrderInfo.orderType = this.$route.query.type;
            if (this.tableOrderInfo.orderType == 2) {
                this.tableOrderInfo.tableName = "0";
            }
            this.$refs.form.validate().then((result) => {
                if (result) {
                    let isSendSms = 1;
                    if (!this.chkSendSms) {
                        isSendSms = 2;
                    }
                    this.tableOrderInfo.isSendSms = isSendSms;
                    this.setItem('sessionStorage', 'tableOrderInfo', this.tableOrderInfo, 7200000);
                    localStorage.setItem('tableOrderInfo', JSON.stringify(this.tableOrderInfo));
                    this.setTimeOut();
                    if (this.tableOrderInfo.orderType == 3) {
                        this.jumpBufft();
                    }
                    else if (this.tableOrderInfo.orderType == 2) {
                        this.$router.push({
                            path: '/takeaway', query: {}
                        })
                    }
                    else {
                        this.$router.push({
                            path: '/dinersNum', query: {}
                        })
                    }
                }
            });
        },
        setTimeOut() {
            window.localStorage.setItem('timeOut', formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'));
        },
        getTableOrderInfo() {
            var tableInfo = JSON.parse(localStorage.getItem('tableOrderInfo'));
            if (tableInfo != null && tableInfo != "" && this.$route.query.type != 2) {
                if (tableInfo.name == null || tableInfo.name == "") {
                    return;
                }
                if (tableInfo.telephone == null || tableInfo.telephone == "") {
                    return;
                }
                this.tableOrderInfo.name = tableInfo.name;
                this.tableOrderInfo.telephone = tableInfo.telephone;
                this.tableOrderInfo.orderType = tableInfo.orderType;
                if (this.tableOrderInfo.restaurantId != tableInfo.restaurantId) {
                    this.tableOrderInfo.number = 0;
                    this.tableOrderInfo.specielle = "";
                }
            }
            this.tableOrderInfo.restaurantId = this.$route.query.restaurantId;
            this.tableOrderInfo.orderType = this.$route.query.type;
            if (this.tableOrderInfo.orderType == 2) {
                this.tableOrderInfo.tableName = "0";
            }
            else {
                this.tableOrderInfo.tableName = this.$route.query.tableName;
            }
            if (this.tableOrderInfo.name != null && this.tableOrderInfo.name != "" && this.tableOrderInfo.name != "guest" && this.tableOrderInfo.telephone != null && this.tableOrderInfo.telephone != "") {
                this.setItem('sessionStorage', 'tableOrderInfo', this.tableOrderInfo, 7200000);
                localStorage.setItem('tableOrderInfo', JSON.stringify(this.tableOrderInfo));
                this.setTimeOut();
                if (this.tableOrderInfo.orderType == 3) {
                    this.jumpBufft();
                }
                else if (this.tableOrderInfo.orderType == 2) {
                    return;
                }
                else {
                    this.$router.push({
                        path: '/dinersNum', query: {}
                    })
                }
            }
        },
        formatPhone(e) {
            let value = this.tableOrderInfo.telephone;
            value = value.replace(/^\+/, '');
            value = value.replace(/\D/g, '');
            this.tableOrderInfo.telephone = value;
        },
        timeOutCheck() {
            let that = this;
            var time = window.localStorage.getItem('timeOut');
            if (time != undefined && time != null && time != "") {
                var dateTimeStamp = new Date(time.replace(/-/g, '/')).getTime();
                var now = new Date().getTime();
                var diffValue = now - dateTimeStamp;
                var minute = 1000 * 60;
                var minC = diffValue / minute;
                if (parseInt(minC) >= 120) {
                    this.$alert(this.$t("common.pageInvalid"), this.$t("common.alert"), {
                        type: 'warning', okLabel: this.$t("common.ok"),
                    }).then(function (result, value) {
                        that.$router.push({
                            path: '/error'
                        })
                    });
                    return false;
                }
                return true;
            }
            this.$alert(this.$t("common.pageInvalid"), this.$t("common.alert"), {
                type: 'warning', okLabel: this.$t("common.ok"),
            }).then(function (result, value) {
                that.$router.push({
                    path: '/error'
                })
            });
            return false;

        },
        jumpBufft() {
            if (!this.timeOutCheck()) {
                return;
            }
            this.billOpen = false;
            let param = {
                restaurantId: this.tableOrderInfo.restaurantId,
                tableName: this.tableOrderInfo.tableName
            };
            this.$get('QRCodeOrder/CheckIsBuffetPackage', param)
                .then(result => {
                    if (result.code == 200) {
                        let response = result.data;
                        if (response) {
                            this.$router.push({
                                path: '/buffet', query: {
                                    isSeft: 1, v: 20260811
                                }
                            })
                        }
                        else {
                            this.$router.push({
                                path: '/buffetSelect', query: {
                                }
                            })
                        }
                    } else {
                        this.$alert('The web cannot be accessed, please contact the manager!', 'Alert');
                    }
                });

        },
        handleFullScreen() {
            let element = document.documentElement;
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
        }
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    .login {
        position: fixed;
        top: 0;
        bottom: 0;
        width: 100%;
        background-color:#fff;
    }
  .logo {
    width: 128px;
    height: 96px;
    display: block;
    margin: 10% auto;
  }
  .indexLogin {
    padding: 0 24px;
    height:100%;
    padding-top:30px;
  }

    
</style>



// WEBPACK FOOTER //
// src/components/Login.vue